/**
 * Centralized text configuration for the application
 * Contains app name and company name for easy customization
 */

const textConfig = Object.freeze({
  appName: 'Concierge',
  companyName: 'Kiln',
});

export default textConfig;